<script setup>
/* Nur noch die feste Wortmarke. Die Schalter (Darstellung, Sprache, Konto, Glocke)
   sitzen in der festen Leiste am oberen Rand — siehe TopBar.vue. Logos, Titelzeile
   und Tag-Zeile gehören zur Logo-Umlaufbahn (OrbitHead.vue).

   Wortmarke gestapelt und zentriert: "AFH" groß, darunter "Hub" in Versalien mit Haarlinien links und
   rechts. Der Text im Markup bleibt "AFH" und "Hub" (Versalien nur per CSS), damit Vorleser und
   Übersetzung nichts davon merken. Der frühere Zierstreifen (.header-accent) ist entfallen: Mit den
   Haarlinien wäre es ein zweiter Akzent direkt darüber. */
</script>

<template>
  <header>
    <div class="wordmark">
      <span class="main">AFH</span>
      <span class="sub">Hub</span>
    </div>
  </header>
</template>

<style scoped>
.wordmark {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: var(--display);
  line-height: 1;
  position: relative;
  z-index: 1;
}
.main {
  font-size: 62px;
  font-weight: 700;
  letter-spacing: 0.14em;
  /* Der Buchstabenabstand hängt auch hinter dem letzten Zeichen: links ausgleichen, damit es mittig sitzt */
  padding-left: 0.14em;
  text-transform: uppercase;
  color: var(--wordmark);
}
.sub {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5em;
  padding-left: 0.5em;
  text-transform: uppercase;
  color: var(--green);
}
/* Haarlinien: 36 px lang, 1 px dünn, vertikal mittig zur Zeile */
.sub::before,
.sub::after {
  content: '';
  flex: none;
  width: 36px;
  height: 1px;
  background: currentColor;
}
/* Ab Desktop-Breite */
@media (min-width: 1024px) {
  .main {
    font-size: 76px;
  }
  .sub {
    font-size: 15px;
  }
}
</style>
